import React from 'react';
import { Box, Text, Grid, Image } from '@chakra-ui/react';

const Card = props => {
  const { img, name, job } = props;
  return (
    <>
      <Box
        w="100%"
        h={['100%',"55vh"]}
        display="flex"
        bg="#fff"
        p='1.5rem'
        borderRadius="24px"
        border="1px solid #F2F2F4"
        justifyContent="space-evenly"
        alignItems="center"
        flexDirection="column"
      >
        <Image src={img} alt="profile" />
        <Text
          fontWeight="500"
          fontSize={['1rem', '1.25rem']}
          textAlign="center"
          whiteSpace="nowrap"
          fontFamily='Duplicate Sans'
          color="#1f1f29"
        >
          {name}
        </Text>
        <Text
          fontSize={['.7rem',".95rem"]}
          mt=".75rem"
          fontFamily='Work Sans'
          mb=".75rem"
          textAlign="center"
          color="#445368"
        >
          {' '}
          {job}
        </Text>
      </Box>
    </>
  );
};

const Usecase = () => {
  return (
    <Box
      bg="#F7F7FD"
      w="full"
      h="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      p={['1.5rem', '3rem', '4rem', '6rem']}
    >
      <Text
        fontSize={['24px', '2rem', '2rem', '3rem']}
        mt="3rem"
        textAlign="center"
        fontFamily='Duplicate Sans'
        fontWeight="500"
      >
        Powering smart product <br />
        across industries
      </Text>
      <Text
        fontSize={['.75rem', '1rem']}
        mb="1rem"
        lineHeight="28px"
        mt="1rem"
        textAlign="center"
        fontFamily='Work Sans'
        color="#445368"
      >Here are some interesting use cases that are powered by NeemblePay
      </Text>
      <Grid
        pb="2rem"
        w='75%'
        placeItems='center'
        gap='6'
        mt={['2rem', '4rem']}
        templateColumns={[
          'repeat(1,1fr)',
          'repeat(1,1fr)',
          'repeat(1,1fr)',
          'repeat(2,1fr)',
        ]}
      >
        <Card
          img="/pos.svg"
          name="Payment Machine"
          job="We offer a seamless biometric transaction 
method. You can withdraw cash and 
also make online payments directly 
with just your biometrics."
        />
        <Card
          img="/merchant.png"
          name="Merchant Store"
          job="We offer a seamless biometric transaction 
          method. You can withdraw cash and 
          also make online payments directly 
          with just your biometrics.

"
        />
      </Grid>
    </Box>
  );
};

export default Usecase;
